/**
 * @generated SignedSource<<2086e5e5e82f936eaf25d1322f0f69f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HiringAsAnIndividual_userProfile$data = {
  readonly firstName: string | null;
  readonly organization: {
    readonly __typename: "Organization";
  } | null;
  readonly professionalTitle: string | null;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "HiringAsAnIndividual_userProfile";
};
export type HiringAsAnIndividual_userProfile$key = {
  readonly " $data"?: HiringAsAnIndividual_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"HiringAsAnIndividual_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HiringAsAnIndividual_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "professionalTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "1983ec8a3b9dd2b636e74355afef082a";

export default node;
